// Bilingual translations (English + Hindi) for BharatKosh UI
import { APP_COPY, VALUE_HI } from "@/lib/i18n_app";
import { VALUE_HI_EXTRA, VALUE_PATTERNS_HI } from "@/lib/i18n_values";

const ALL_HI = { ...VALUE_HI_EXTRA, ...VALUE_HI };
export const tValue = (lang, v) => {
  if (lang !== "hi" || typeof v !== "string") return v;
  if (ALL_HI[v]) return ALL_HI[v];
  for (const [re, fn] of VALUE_PATTERNS_HI) { const m = v.match(re); if (m) return fn(m, (x) => ALL_HI[x] || x); }
  return v;
};
export const translations = {
  en: {
    app_name: "BharatKosh Loan Bazaar",
    tagline: "Prepare once. Let suitable banks find you.",
    // Nav
    home: "Home",
    how_it_works: "How it works",
    for_msmes: "For MSMEs",
    for_banks: "For Banks",
    schemes: "Schemes",
    cgtmse: "CGTMSE",
    about: "About",
    contact: "Contact",
    login: "Log in",
    register: "Register",
    logout: "Log out",
    // Common
    dashboard: "Dashboard",
    profile: "Profile",
    documents: "Documents",
    applications: "Applications",
    notifications: "Notifications",
    grievances: "Grievances",
    settings: "Settings",
    borrowers: "Borrowers",
    save: "Save",
    save_continue: "Save & Continue",
    cancel: "Cancel",
    submit: "Submit",
    next: "Next",
    back: "Back",
    create: "Create",
    delete: "Delete",
    edit: "Edit",
    view: "View",
    yes: "Yes",
    no: "No",
    loading: "Loading…",
    empty: "Nothing to show yet.",
    // Home
    hero_headline: "Your business should not chase every bank.",
    hero_subheadline: "Create one MSME Financial Passport, explore Madhya Pradesh and central schemes, receive indicative lender interest with consent and track your application until disbursement.",
    check_readiness: "Check My Business Readiness",
    register_lender: "Register as a Lender",
    // Disclaimer
    disclaimer_short: "BharatKosh Loan Bazaar is a technology and loan-facilitation platform. It is not a bank, NBFC, government department, credit-guarantee provider or loan-sanctioning authority.",
    // Borrower
    quick_assessment: "Quick Assessment",
    financial_passport: "Financial Passport",
    readiness_report: "Readiness Report",
    funding_requirements: "Funding Requirements",
    financing_routes: "Financing Routes",
    scheme_matches: "Scheme Matches",
    lender_interest: "Lender Interest",
    offer_comparison: "Offer Comparison",
    consent_centre: "Consent Centre",
    subsidy_tracker: "Subsidy Tracker",
    improvement_plan: "Improvement Plan",
    // Passport sections
    section_business_identity: "Business Identity",
    section_promoter: "Promoter Details",
    section_operations: "Business Operations",
    section_financial: "Financial Information",
    section_banking: "Banking Information",
    section_gst: "GST Information",
    section_liabilities: "Existing Liabilities",
    section_funding: "Funding Requirement",
    section_collateral: "Collateral",
    section_scheme: "Scheme Attributes",
    section_documents: "Documents",
    section_consent: "Consent & Discoverability",
    // Statuses
    bank_ready: "Bank Ready",
    conditionally_ready: "Conditionally Ready",
    preparation_required: "Preparation Required",
    insufficient_info: "Insufficient Information",
    // Bank
    opportunity_marketplace: "Opportunity Marketplace",
    saved_opportunities: "Saved Opportunities",
    policies: "Credit Policies",
    analytics: "Analytics",
    branches: "Branches",
    // Government
    district_map: "District Credit Map",
    sector_analysis: "Sector Analysis",
    scheme_utilization: "Scheme Utilization",
    inclusion_metrics: "Inclusion Metrics",
    // Admin
    users: "Users",
    lenders: "Lenders",
    audit_logs: "Audit Logs",
  },
  hi: {
    app_name: "भारतकोश लोन बाजार",
    tagline: "एक बार तैयारी करें। उपयुक्त बैंक आपको खोजने दें।",
    home: "होम",
    how_it_works: "यह कैसे काम करता है",
    for_msmes: "MSME के लिए",
    for_banks: "बैंकों के लिए",
    schemes: "योजनाएँ",
    cgtmse: "CGTMSE",
    about: "हमारे बारे में",
    contact: "संपर्क",
    login: "लॉग इन",
    register: "पंजीकरण",
    logout: "लॉग आउट",
    dashboard: "डैशबोर्ड",
    profile: "प्रोफ़ाइल",
    documents: "दस्तावेज़",
    applications: "आवेदन",
    notifications: "सूचनाएँ",
    grievances: "शिकायतें",
    settings: "सेटिंग्स",
    borrowers: "उधारकर्ता",
    save: "सहेजें",
    save_continue: "सहेजें और आगे बढ़ें",
    cancel: "रद्द करें",
    submit: "जमा करें",
    next: "आगे",
    back: "वापस",
    create: "बनाएँ",
    delete: "हटाएँ",
    edit: "संपादित करें",
    view: "देखें",
    yes: "हाँ",
    no: "नहीं",
    loading: "लोड हो रहा है…",
    empty: "अभी दिखाने के लिए कुछ नहीं है।",
    hero_headline: "आपके व्यवसाय को हर बैंक के पीछे नहीं भागना चाहिए।",
    hero_subheadline: "एक MSME वित्तीय पासपोर्ट बनाएँ, मध्य प्रदेश और केंद्रीय योजनाओं का अन्वेषण करें, सहमति के साथ ऋणदाता की सांकेतिक रुचि प्राप्त करें और वितरण तक अपने आवेदन को ट्रैक करें।",
    check_readiness: "मेरे व्यवसाय की तत्परता जाँचें",
    register_lender: "ऋणदाता के रूप में पंजीकरण करें",
    disclaimer_short: "भारतकोश लोन बाजार एक तकनीकी एवं ऋण-सुविधा मंच है। यह बैंक, NBFC, सरकारी विभाग, क्रेडिट गारंटी प्रदाता या ऋण-स्वीकृति प्राधिकरण नहीं है।",
    quick_assessment: "त्वरित मूल्यांकन",
    financial_passport: "वित्तीय पासपोर्ट",
    readiness_report: "तत्परता रिपोर्ट",
    funding_requirements: "वित्तीय आवश्यकताएँ",
    financing_routes: "वित्तपोषण मार्ग",
    scheme_matches: "योजना मिलान",
    lender_interest: "ऋणदाता की रुचि",
    offer_comparison: "प्रस्ताव तुलना",
    consent_centre: "सहमति केंद्र",
    subsidy_tracker: "अनुदान ट्रैकर",
    improvement_plan: "सुधार योजना",
    section_business_identity: "व्यवसाय पहचान",
    section_promoter: "प्रवर्तक विवरण",
    section_operations: "व्यवसाय संचालन",
    section_financial: "वित्तीय जानकारी",
    section_banking: "बैंकिंग जानकारी",
    section_gst: "GST जानकारी",
    section_liabilities: "मौजूदा देनदारियाँ",
    section_funding: "वित्तपोषण आवश्यकता",
    section_collateral: "संपार्श्विक",
    section_scheme: "योजना विशेषताएँ",
    section_documents: "दस्तावेज़",
    section_consent: "सहमति एवं खोज योग्यता",
    bank_ready: "बैंक-तैयार",
    conditionally_ready: "सशर्त तैयार",
    preparation_required: "तैयारी आवश्यक",
    insufficient_info: "अपर्याप्त जानकारी",
    opportunity_marketplace: "अवसर बाजार",
    saved_opportunities: "सहेजे गए अवसर",
    policies: "क्रेडिट नीतियाँ",
    analytics: "विश्लेषण",
    branches: "शाखाएँ",
    district_map: "जिला ऋण मानचित्र",
    sector_analysis: "क्षेत्र विश्लेषण",
    scheme_utilization: "योजना उपयोग",
    inclusion_metrics: "समावेशन मापदंड",
    users: "उपयोगकर्ता",
    lenders: "ऋणदाता",
    audit_logs: "ऑडिट लॉग",
  },
};

Object.assign(translations.en, APP_COPY.en);
Object.assign(translations.hi, APP_COPY.hi);

export function t(lang, key) {
  const dict = translations[lang] || translations.en;
  return dict[key] || translations.en[key] || key;
}
